import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=0dabf5db&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dabf5db')) {
      api.createRecord('0dabf5db', component.options)
    } else {
      api.reload('0dabf5db', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=0dabf5db&", function () {
      api.rerender('0dabf5db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8vh90A35nQn5U/JS/comp/ErrorMessage.vue"
export default component.exports